export const useMoreMenuCellStyles = () => {
  return {
    dataCell: {
      verticalAlign: 'top !important',
    },
  };
};
